import { CriterioTipoDado } from '@shared/criterio';

export class VendaCampo {
  constructor(
    public id: string,
    public descricao: string,
    public tipo: CriterioTipoDado,
  ) {}
  tipoColuna: string = 'campo';
  path = this.id.split('.');
}

export const VendaCampos: { [key: string]: VendaCampo } = {
  statusComissao: new VendaCampo('statusComissao', 'Status Comissão', CriterioTipoDado.alfanumerico),
  valorTotal: new VendaCampo('valorTotal', 'Valor (R$)', CriterioTipoDado.valor),
  idVenda: new VendaCampo('idVenda', 'Venda', CriterioTipoDado.alfanumerico),
  'calculo.valorComissao': new VendaCampo(
    'calculo.valorComissao',
    'Comissão Calculada (R$)',
    CriterioTipoDado.valor,
  ),
  'comissao.valorCalculado': new VendaCampo(
    'comissao.valorCalculado',
    'Comissão Calculada (R$)',
    CriterioTipoDado.valor,
  ),
  'comissao.valorAutorizado': new VendaCampo(
    'comissao.valorAutorizado',
    'Comissão Autorizada (R$)',
    CriterioTipoDado.valor,
  ),
  'comissao.valorDisponivel': new VendaCampo(
    'comissao.valorDisponivel',
    'Comissão a Pagar (R$)',
    CriterioTipoDado.valor,
  ),
} as const;
